<a class="js-saved-cart-details" tabindex="0" [routerLink]="{ cxRoute: 'savedcartDetails', params: row } | cxUrl">
  <app-tooltip-text
    class="sku-truncate"
    [tooltipContent]="row.name"
    [content]="row.name"
    [charactersLimit]="20"
    placement="bottom"
  >
  </app-tooltip-text>
</a>
